import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEyeOff16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconEyeOff16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m4.286 12.42-.667.668a.5.5 0 1 1-.707-.707l9.469-9.469a.5.5 0 0 1 .707.707l-.576.576c1.03.899 1.757 1.961 2.202 2.734a2.13 2.13 0 0 1 0 2.142c-.932 1.62-3.101 4.509-6.714 4.509-1.474 0-2.707-.48-3.714-1.16m7.517-7.516c.928.793 1.605 1.761 2.044 2.524.207.359.207.785 0 1.144-.903 1.57-2.814 4.008-5.847 4.008a5.54 5.54 0 0 1-2.99-.882l1.243-1.244a3.01 3.01 0 0 0 4.2-4.2zM9.731 6.976 6.976 9.731a2.014 2.014 0 0 0 2.966-1.21 2 2 0 0 0-.211-1.545M8 3.42c.76 0 1.45.154 2.072.408l.758-.758A6.4 6.4 0 0 0 8 2.42c-3.613 0-5.782 2.889-6.715 4.51a2.13 2.13 0 0 0 0 2.141c.336.583.831 1.33 1.496 2.048l.707-.707a10.4 10.4 0 0 1-1.336-1.84 1.13 1.13 0 0 1 0-1.144C3.055 5.858 4.967 3.42 8 3.42"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconEyeOff16);
